/**
 * @generated SignedSource<<7788b65c455dcf97569800d9d87c6deb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIssueOverviewIssueItem_issue$data = {
  readonly id: string;
  readonly resolved: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIssueOverviewIssueItemContent_issue">;
  readonly " $fragmentType": "WidgetIssueOverviewIssueItem_issue";
};
export type WidgetIssueOverviewIssueItem_issue$key = {
  readonly " $data"?: WidgetIssueOverviewIssueItem_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIssueOverviewIssueItem_issue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIssueOverviewIssueItem_issue",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resolved",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetIssueOverviewIssueItemContent_issue"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "1585049ea2ee1427dec2d66593595ff2";

export default node;
